var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"button-loader",style:(_vm.$options.loaderStyles(_vm.props))})}
var staticRenderFns = []

export { render, staticRenderFns }